import { AlertDangerIcon, EllipsisText, Feedback, Stack } from 'canoe';
import { useFormikContext } from 'formik';
import React from 'react';

import { ContentPlacement } from '@candu-ai/placement/types';
import {
  CompletedStepSettings,
  EditLinkButton,
  InlineMessage,
} from 'craft/containers/Toolbox/tabs/Placements/components/ui';
import { getPlacementUrlText } from 'craft/containers/Toolbox/tabs/Placements/utils';
import { useToolboxTab } from 'craft/state';

interface Props {
  onEdit: VoidFunction;
}

export const InlineUrl = ({ onEdit }: Props) => {
  const { values } = useFormikContext<ContentPlacement>();
  const { forcePlacementsTab } = useToolboxTab();

  const placementUrl = getPlacementUrlText(values);

  return (
    <>
      <CompletedStepSettings hasError={!placementUrl}>
        <Stack space="xs" css={{ overflow: 'hidden' }}>
          <span>
            <strong>Placement URL</strong>
          </span>
          <span>
            <EllipsisText content={placementUrl}>
              <div>{placementUrl}</div>
            </EllipsisText>
          </span>
        </Stack>
        <EditLinkButton
          appearance="text"
          inline
          size="small"
          variant="white"
          fontWeight="xbold"
          onClick={onEdit}
          disabled={forcePlacementsTab && !!values.id}
        >
          edit
        </EditLinkButton>
      </CompletedStepSettings>
      {!placementUrl && (
        <InlineMessage>
          <Feedback ml="xxs" color="danger" mode="alert" alertIcon={AlertDangerIcon}>
            Required
          </Feedback>
        </InlineMessage>
      )}
    </>
  );
};
